module.exports = __webpack_public_path__ + "img/yishiyong@3x.a741985f.png";